import { Pipe, PipeTransform } from '@angular/core';

import { NumberHelperService } from '@mirage-projects/cw-utils';

@Pipe({
    name: 'bytes',
    standalone: false,
})
export class BytesPipe implements PipeTransform {
    constructor(private numberHelperService: NumberHelperService) {}

    transform(bytes: number | null, precision = 1): string | null {
        if (!bytes) {
            return '-';
        }
        const signMult = bytes > 0 ? 1 : -1;
        bytes = Math.abs(bytes);
        const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        const unitNumber = Math.floor(Math.log(bytes) / Math.log(1024));
        const resultNumber = (signMult * bytes) / Math.pow(1024, Math.floor(unitNumber));
        const resultFormated = this.numberHelperService.toFixedWithPrecision(resultNumber, precision);
        return `${resultFormated} ${units[unitNumber]}`;
    }
}
